export enum BlockCategory {
  Start = 'Start',
  Logic = 'Logic',
  Data = 'Data',
  Experience = 'Experience',
  Integration = 'Integration',
  Ai = 'Ai',
  Export = 'Export',
  Skill = 'Skill',
  Obsolete = 'Obsolete',
  Placeholder = 'Placeholder',
}

export const BLOCK_CATEGORY_NAMES: Record<BlockCategory, string> = {
  [BlockCategory.Start]: 'Start',
  [BlockCategory.Logic]: 'Logic',
  [BlockCategory.Data]: 'Data',
  [BlockCategory.Experience]: 'Experience',
  [BlockCategory.Integration]: 'Integration',
  [BlockCategory.Ai]: 'AI',
  [BlockCategory.Export]: 'Export',
  [BlockCategory.Skill]: 'Skill',
  [BlockCategory.Obsolete]: 'Obsolete',
  [BlockCategory.Placeholder]: 'Placeholder',
};

/**
 * BlockSafetyLevel refers to whether a block performs any actions that may make it unsafe to run
 * with actual patient data during a test run. For example, if a block sends an SMS text message,
 * it must be marked "Unsafe" since if the block is run with actual patient data, it would send
 * a message to an actual patient during a test run (undesired behavior).
 * While this property is currently unused, it is a reasonable property of the blockType.
 */
export enum BlockSafetyLevel {
  Safe = 'Safe',
  Unsafe = 'Unsafe',
}

/**
 * This variant is restricted to very specific use cases.
 * You must get approval from design before adding to this list.
 */
export enum BlockCustomIconVariant {
  Iterator = 'Iterator',
  SubFlow = 'SubFlow',
  Script = 'Script',
  Text = 'Text',
}

export enum BlockLifeCycle {
  Internal = 'Internal',
  Published = 'Published',
  Beta = 'Beta',
  Developer = 'Developer',
  Retired = 'Retired',
  Obsolete = 'Obsolete',
}
